export default "__VITE_ASSET__mLwVaCoG__"